<template>
    <div class="form">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="box-layout-inner">
                    <register-form></register-form>
                </div>
            </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                isCheckout: true
            }
        },
        components: {
            'register-form': require('../../auth/forms/register.vue')
        },
        created () {

            /**Checking if the user is currently logged in**/
            axios.get('/camp-booking/users/current')
                .then(response => {
                    if(response.data.data.user_id == null) {
                        this.$router.push({name: 'auth.login'});
                        return false;
                    }
                })

            /**
             * Password validation regex
             **/
            this.$validator.remove('password');// Want to remove it incase it already exists.
            this.$validator.extend('password', {
                getMessage: field => this.$root.locale.account.register.text_password_error_message,
                validate: value => Array.isArray(value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,8}$/))
            });

            /**
             * Setting the headers
             **/
            this.$root.headers = {
                navigate: {
                    name: 'account.overview'
                },
                title: this.$root.locale.miscellaneous.page_headings.account.update_account_details,

            }
        }
    }
</script>



// WEBPACK FOOTER //
// AccountDetails.vue?f8c997f6